module.exports = __webpack_public_path__ + "static/media/galeria-fotos-1-big.46eb525e.png";